import { PropsWithChildren } from 'react'

export type LinkComponentType = (props: LinkProps) => React.JSX.Element

type LinkProps = PropsWithChildren<{
  href: string
  className?: string
  onClick?: () => void
  editorClick?: () => void
  target?: string
  rel?: string
}>

type Props = LinkProps & {
  LinkComponent: LinkComponentType
}

export const CLink = (props: Props) => {
  const { LinkComponent, ...rest } = props
  return <LinkComponent {...rest} />
}
